<template>
  <!-- <div id="main-wrapper pt-0" class="show"> -->
  <div class="landing_page">
    <div class="homepage">
      <div class="container">
        <el-card class="box-card" style="margin-top: 20px; padding-top: 20px">
          <el-header style="text-align: center">
            <h1>Company information authentication</h1>
          </el-header>
          <div class="row">
            <div class="col-xl-12 col-lg-12" style="margin-top: 40px">
              <section>
                <el-steps
                  :active="activeStep"
                  align-center
                  finish-status="success"
                >
                  <el-step title="General"></el-step>
                  <el-step title="Representives"></el-step>
                  <el-step title="Beneficial Owners"></el-step>
                  <el-step title="Documentation"></el-step>
                  <el-step title="Banking Info"></el-step>
                  <el-step title="Questionnaire"></el-step>
                </el-steps>
              </section>
            </div>
          </div>
          <div class="row">
            <div
              class="col-xl-12 col-lg-12"
              style="margin-left: 10%; margin-top: 40px"
            >
              <!-- <el-page-header content="Authentication"> </el-page-header> -->
              <el-form
                ref="elForm"
                :model="formData"
                :rules="rules"
                size="medium"
                label-width="100px"
                label-position="top"
              >
                <el-col :span="18">
                  <el-row>
                    <el-col :span="22">
                      <h2>
                        <span slot="label">
                          Please be as thorough as possible as this will help
                          save time on additional follow up.</span
                        >
                      </h2>
                      <p style="color: #999; margin: 10px 0 10px 0"></p>
                      <br />
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="20">
                  <el-form-item label="" prop="s6_is_sanctioned" required>
                    <h3>
                      <span slot="label">
                        Has this entity ever done business in, spent significant
                        time in or otherwise had significant contact with
                        countries sanctioned by the U.S.?
                      </span>
                      <p style="color: #999; margin: 0">
                        Including but not limit to: Cuba, Iraq, Libya, North
                        Korea ,Sudan, Yemen, Iran, Lebanon, Pakistan, Syria.
                        Check out the link above to find more information.
                      </p>
                    </h3>
                    <el-radio-group
                      v-model="formData.s6_is_sanctioned"
                      size="medium"
                    >
                      <el-radio
                        v-for="(item, index) in yesOrNoOptions()"
                        :key="index"
                        :label="item.value"
                        >{{ item.label }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="20">
                  <el-form-item
                    label=""
                    prop="s6_is_politically_exposed"
                    required
                  >
                    <h3>
                      <span slot="label">
                        Are you or any beneficial owner of the entity considered
                        to be a politically exposed person?
                      </span>
                    </h3>
                    <p style="color: #999; margin: 0">
                      e.g – Are they senior military, government, or political
                      officials, or relatives or associates of such officials?
                    </p>
                    <el-radio-group
                      v-model="formData.s6_is_politically_exposed"
                      size="medium"
                    >
                      <el-radio
                        v-for="(item, index) in yesOrNoOptions()"
                        :key="index"
                        :label="item.value"
                        >{{ item.label }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="20">
                  <el-form-item label="" prop="s6_political_official" required>
                    <h3>
                      <span slot="label">
                        Are you or any beneficial owner closely associated with
                        an immediate family member of a senior military,
                        government,or political official?
                      </span>
                    </h3>
                    <!-- <p style="color: #999; margin: 0">
                      e.g – Are they senior military, government, or political
                      officials, or relatives or associates of such officials?
                    </p> -->
                    <el-radio-group
                      v-model="formData.s6_political_official"
                      size="medium"
                    >
                      <el-radio
                        v-for="(item, index) in yesOrNoOptions()"
                        :key="index"
                        :label="item.value"
                        >{{ item.label }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="20">
                  <el-form-item label="Purpose" prop="s6_purpose" required>
                    <el-input
                      v-model="formData.s6_purpose"
                      type="textarea"
                      placeholder="Please explain the use/purpose of the digital currency bought from/sold via OTC trading"
                      :autosize="{ minRows: 4, maxRows: 4 }"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="20">
                  <el-form-item
                    label="Nature of Business"
                    prop="s6_business"
                    required
                  >
                    <el-input
                      v-model="formData.s6_business"
                      type="textarea"
                      placeholder="Provide us a brief description of your business. Indicate your main business products and services, main customer types, and geographies served."
                      :autosize="{ minRows: 4, maxRows: 4 }"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="20">
                  <el-form-item
                    label="Source Funds"
                    prop="s6_source_funds"
                    required
                  >
                    <el-input
                      v-model="formData.s6_source_funds"
                      type="textarea"
                      placeholder="Please describe the initial source of funds used to incorporate the entity. (Investors, ICO, Salary from prior employment etc.)"
                      :autosize="{ minRows: 4, maxRows: 4 }"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="20">
                  <el-form-item
                    label="How would you use this OTC account?"
                    prop="s6_how_use_otc"
                    required
                  >
                    <el-input
                      v-model="formData.s6_how_use_otc"
                      type="textarea"
                      placeholder="The assets that you are interested to buy/sell and the estimated amount per month"
                      :autosize="{ minRows: 4, maxRows: 4 }"
                      :style="{ width: '100%' }"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <!-- <el-col :span="6" :offset="0"
                  ><el-button @click="goback">Previous</el-button></el-col
                > -->
                <el-col :span="24" :offset="8">
                  <el-form-item size="large">
                    <el-button type="primary" @click="submitForm"
                      >Submit</el-button
                    >
                    <el-button @click="resetForm">Reset</el-button>
                  </el-form-item></el-col
                >
                <div class="row">
                  <div class="col-xl-2 col-lg-2" style="margin-top: 40px">
                    <el-form-item size="large"> </el-form-item>
                  </div>
                  <div class="col-xl-4 col-lg-4" style="margin-top: 40px"></div>
                </div>
              </el-form>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>
<script>
// import FileUpload from "../../components/plugins/FileUpload2.vue";
import {
  otc_auth_status,
  get_info,
  att_info,
} from "../../plugins/api/account_otc";
import { yesOrNoOptions } from "../../plugins/data/form_base_data";
export default {
  components: {},
  props: [],
  data() {
    return {
      activeStep: 5,
      formData: {
        process: 6,
        s6_is_sanctioned: `0`,
        s6_is_politically_exposed: `0`,
        s6_political_official: `0`,
      },
      rules: {
        s6_is_sanctioned: [
          {
            message: "*",
            trigger: "blur",
          },
        ],
        s6_is_politically_exposed: [
          {
            message: "*",
            trigger: "blur",
          },
        ],
        s6_political_official: [
          {
            message: "*",
            trigger: "blur",
          },
        ],
        s6_purpose: [
          {
            required: true,
            message:
              "Please explain the use/purpose of the digital currency bought from/sold via OTC trading",
            trigger: "blur",
          },
        ],
        s6_business: [
          {
            required: true,
            message:
              "Provide us a brief description of your business. Indicate your main business products and services, main customer types, and geographies served.",
            trigger: "blur",
          },
        ],
        s6_source_funds: [
          {
            required: true,
            message:
              "Please describe the initial source of funds used to incorporate the entity. (Investors, ICO, Salary from prior employment etc.)",
            trigger: "blur",
          },
        ],
        s6_how_use_otc: [
          {
            required: true,
            message:
              "The assets that you are interested to buy/sell and the estimated amount per month.",
            trigger: "blur",
          },
        ],
      },
      idFileAction: "https://jsonplaceholder.typicode.com/posts/",
      idFilefileList: [],
      selfieAction: "https://jsonplaceholder.typicode.com/posts/",
      selfiefileList: [],
      addrProveAction: "https://jsonplaceholder.typicode.com/posts/",
      addrProvefileList: [],
      idfileTypeOptions: [
        {
          label: "Passport",
          value: 1,
        },
        {
          label: "U.S. driver's license",
          value: 2,
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    otc_auth_status().then((res) => {
      console.log(res);
      if (res && res.data) {
        // console.log("reg attach info complete!");
      }
    });

    get_info(
      `/account_otc/get_company_info?process=${this.formData.process}`
    ).then((res_query) => {
      if (res_query.data) {
        this.$Message.success("This information has been stored");
        // this.formData.s6_is_sanctioned = "0";
        // this.formData.s6_is_politically_exposed = "0";
        // this.formData.s6_political_official = "0";
        if (res_query.data.s6_business) {
          this.formData = res_query.data;
          this.formData.s6_is_sanctioned = `${res_query.data.s6_is_sanctioned}`;
          this.formData.s6_is_politically_exposed = `${res_query.data.s6_is_politically_exposed}`;
          this.formData.s6_political_official = `${res_query.data.s6_political_official}`;
        }
      } else {
      }
    });
  },
  mounted() {},
  methods: {
    yesOrNoOptions() {
      return yesOrNoOptions;
    },
    setidfileurl(url) {
      this.formData.idFile = url;
    },
    setselfiefileurl(url) {
      this.formData.selfie = url;
    },
    setprovefileurl(url) {
      this.formData.addrProve = url;
    },
    submitForm() {
      this.$refs["elForm"].validate((valid) => {
        if (!valid) return;
        this.formData.process = 6;
        att_info("/account_otc/att_company_info", this.formData).then((res) => {
          if (res.code == 0 || res.code == 18289475) {
            this.$alert(
              "You have submitted your profile and we will complete the review as soon as possible and notify you by email after the approval",
              "prompt",
              {
                confirmButtonText: "Enter",
                callback: (action) => {
                  this.$router.push("/accounts");
                },
              }
            );
          } else if (res.code == 38914211) {
            setTimeout(function () {
              this.$message.success(
                "The submission was successful, please wait for our review."
              );
              this.$router.push("/accounts");
            }, 2000);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    resetForm() {
      this.$refs["elForm"].resetFields();
    },
    idFileBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    selfieBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    addrProveBeforeUpload(file) {
      let isRightSize = file.size / 1024 / 1024 < 2;
      if (!isRightSize) {
        this.$message.error("The file size is greater than 2MB");
      }
      return isRightSize;
    },
    goback() {
      this.$router.push("/reg/inc_cert/step5");
    },
  },
};
</script>
<style>
.el-icon-plus:before {
  top: 70px;
  position: relative;
}
.el-upload__tip {
  line-height: 1.2;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>